export default __webpack_public_path__ + "static/media/default_avatar.d10fc897.svg";